import React, { useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * LanguageRouter Component
 * Handles language detection from URL path (e.g., /de/page)
 * English is default and doesn't require /en/ prefix
 */
const LanguageRouter = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Valid language codes (excluding 'en' as it's default)
    const validLangs = ['de'];

    // If language in URL is valid (non-English), set it
    if (lang && validLangs.includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    } else if (lang === 'en') {
      // If /en/ is in URL, redirect to remove it (English is default)
      const newPath = location.pathname.replace(/^\/en(\/|$)/, '/');
      if (newPath !== location.pathname) {
        history.replace(newPath + location.search);
      }
      i18n.changeLanguage('en');
    } else if (lang && !validLangs.includes(lang)) {
      // Invalid language in URL, redirect to English (no prefix)
      const newPath = location.pathname.replace(`/${lang}`, '');
      history.replace(newPath || '/');
    } else {
      // No language in URL path - this means English (default)
      if (i18n.language !== 'en') {
        i18n.changeLanguage('en');
      }
    }
  }, [lang, i18n, history, location]);

  return <>{children}</>;
};

export default LanguageRouter;
